const TOKEN_KEY = 'token'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY) || ''
}

export function isLoggedIn() {
  const token = localStorage.getItem(TOKEN_KEY)
  const user = localStorage.getItem('yinlv_user')
  return !!(token && user)
}

export function setToken(token, remember = true) {
  const normalizedToken = String(token || '').trim()

  removeToken()

  if (!normalizedToken) {
    return ''
  }

  const storage = remember ? localStorage : sessionStorage
  storage.setItem(TOKEN_KEY, normalizedToken)
  return normalizedToken
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem("yinlv_user")
}

export default {
  getToken,
  setToken,
  removeToken
}
